export const generatedSourceIngestionLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-06-19T00:00:00.000Z",
  "mode": "deterministic-source-ingestion-work-order-ledger",
  "operatingRule": "A source registry entry is not a model-ready payload. Every source needs query/request metadata, raw and normalized hashes, unit mapping, uncertainty treatment, license review, tests, and reviewer approval before it can promote business or science conclusions.",
  "sourceCount": 33,
  "workOrderCount": 33,
  "blockedWorkOrderCount": 33,
  "domainCounts": {
    "ephemeris-and-astronomy": 7,
    "small-body-and-resource-evidence": 5,
    "trajectory-and-optimization": 5,
    "communications-and-standards": 2,
    "economics-and-business-evidence": 5,
    "systems-engineering-and-governance": 1,
    "space-environment": 3,
    "materials-and-process-modeling": 5
  },
  "requiredPayloadArtifacts": [
    "queryOrRequest",
    "captureTimestamp",
    "rawPayloadHash",
    "normalizedRecordHash",
    "licenseOrTermsReview",
    "unitsMap",
    "uncertaintyMap",
    "citation",
    "parserVersion",
    "fixtureOrToleranceTest",
    "reviewerApproval"
  ],
  "priorityQueue": [
    {
      "id": "source-ingest-cad-api",
      "sourceId": "cad-api",
      "title": "SBDB Close Approach Data API",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "nextAction": "Capture a reviewed close-approach-api payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-ae487ba413cc055f5780b588f01397328e6b175869437d23576aad46b9b9ce71"
    },
    {
      "id": "source-ingest-dymos",
      "sourceId": "dymos",
      "title": "Dymos",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "nextAction": "Capture a reviewed optimal-control-library payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5f0c857d5f01ab9369fac47f0b965676cd1d5551ba22f91f1294e64872c344d0"
    },
    {
      "id": "source-ingest-esa-psa",
      "sourceId": "esa-psa",
      "title": "ESA Planetary Science Archive",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "nextAction": "Capture a reviewed planetary-mission-archive payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-e943bde41a94f1789b36698e84beaf971e81fece7b2e6162591edfd8afdad615"
    },
    {
      "id": "source-ingest-gmat",
      "sourceId": "gmat",
      "title": "General Mission Analysis Tool",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "nextAction": "Capture a reviewed mission-analysis-tool payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-9dc7bf9fb79de628782cf8b0323b4f3813914992b426fe4dc7a3daf3eae8833d"
    },
    {
      "id": "source-ingest-horizons-api",
      "sourceId": "horizons-api",
      "title": "JPL Horizons API",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "nextAction": "Capture a reviewed ephemeris-api payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-87c8e4bb328d92196995c2a99ceb331d2f9e3c6616f90eb5b75f48e3a1e8af10"
    },
    {
      "id": "source-ingest-horizons-mercury-2024",
      "sourceId": "horizons-mercury-2024",
      "title": "JPL Horizons Mercury Physical Data",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "nextAction": "Capture a reviewed body-physical-data payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-e7d428df65ab7cdaf3a65ff87baef2566e262a1959f270ef265ea8d5963853d8"
    },
    {
      "id": "source-ingest-iau-sofa",
      "sourceId": "iau-sofa",
      "title": "Standards of Fundamental Astronomy",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "nextAction": "Capture a reviewed astronomy-standards payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-4e64bcced35d7a9497724400b98fb6e2a86515ae74b1c7048f63bbad8b99f06e"
    },
    {
      "id": "source-ingest-jaxa-darts",
      "sourceId": "jaxa-darts",
      "title": "DARTS Space Science Data Archive",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "nextAction": "Capture a reviewed space-science-archive payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-a4b69d55b7d4cc9a233b493a92ff3e8497fcf65a45bf8e332e389d21af096fb2"
    },
    {
      "id": "source-ingest-mpc",
      "sourceId": "mpc",
      "title": "Minor Planet Center Data",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "nextAction": "Capture a reviewed small-body-observation-archive payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-6f4ec4d25fd364055d8c199c2c900fb140fcfd4c471ff4343dd8cb45ab928bc7"
    },
    {
      "id": "source-ingest-nasa-mercury",
      "sourceId": "nasa-mercury",
      "title": "Mercury Facts",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "nextAction": "Capture a reviewed official-factsheet payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5b53cd471db10365d2e0a9126eb6fd841ddbed0292a6202d9865d5c32e634bb3"
    },
    {
      "id": "source-ingest-nist-codata",
      "sourceId": "nist-codata",
      "title": "2022 CODATA Fundamental Physical Constants",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "nextAction": "Capture a reviewed physical-constants payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5c1b9ed4354c988060da39a5fd86d1e0758fc9b447ffff3389a35c5862d4f85d"
    },
    {
      "id": "source-ingest-openmdao",
      "sourceId": "openmdao",
      "title": "OpenMDAO",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "nextAction": "Capture a reviewed optimization-framework payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-c6f5e90eb17541785cd427c2bbd3aa01691aca58bd56e984e39f91c732f1a20b"
    },
    {
      "id": "source-ingest-orekit",
      "sourceId": "orekit",
      "title": "Orekit",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "nextAction": "Capture a reviewed astrodynamics-library payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-32e680e406eeddf3facdf231b3f530178321968183591cbb59f8a4f88d12eec3"
    },
    {
      "id": "source-ingest-pds",
      "sourceId": "pds",
      "title": "Planetary Data System",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "nextAction": "Capture a reviewed mission-data-archive payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-928a0c47b33ef9948c19972c1b4ecf480cf557b36aad1191673dce710ab29a11"
    },
    {
      "id": "source-ingest-sbdb-api",
      "sourceId": "sbdb-api",
      "title": "JPL Small-Body Database API",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "nextAction": "Capture a reviewed small-body-orbit-api payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-03df633e2ee73cac09d65f2a2f5428e468e6ac89008e3f4378d6c8fd575ca8a5"
    },
    {
      "id": "source-ingest-spice-gf",
      "sourceId": "spice-gf",
      "title": "SPICE Geometry Finder",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "nextAction": "Capture a reviewed ephemeris-event-software payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-067366bfd5d48f4d3ec03a31d3ff19007a6aa77d692b3741d5949721a6fb75b8"
    },
    {
      "id": "source-ingest-tudat",
      "sourceId": "tudat",
      "title": "Tudat Space / TudatPy",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "nextAction": "Capture a reviewed astrodynamics-toolkit payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-036f1a6704d95b5f93ff6bca5ea75a05e823e85cb50ec2048eda3a5267a33a1a"
    },
    {
      "id": "source-ingest-cantera",
      "sourceId": "cantera",
      "title": "Cantera",
      "domain": "materials-and-process-modeling",
      "priority": "P1",
      "nextAction": "Capture a reviewed chemistry-transport-toolkit payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-db1a361118b0599a32f646adbfd56174b3632166b2e0ecee2f1a8033a365161b"
    },
    {
      "id": "source-ingest-materials-project",
      "sourceId": "materials-project",
      "title": "Materials Project API",
      "domain": "materials-and-process-modeling",
      "priority": "P1",
      "nextAction": "Capture a reviewed materials-property-api payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-cf340e050bde6a9a086fea668420d741780db2d71381b6b8de0222967e39b600"
    },
    {
      "id": "source-ingest-moose-framework",
      "sourceId": "moose-framework",
      "title": "MOOSE Framework",
      "domain": "materials-and-process-modeling",
      "priority": "P1",
      "nextAction": "Capture a reviewed multiphysics-framework payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-f78f596ae140aade5b7d0fd53aa491e4a0478dca93cf5ea1c391bfe57ba93d7a"
    },
    {
      "id": "source-ingest-nasa-ccmc",
      "sourceId": "nasa-ccmc",
      "title": "Community Coordinated Modeling Center",
      "domain": "space-environment",
      "priority": "P1",
      "nextAction": "Capture a reviewed space-weather-modeling-center payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5c43fc31587c76573078911a506a40bae0680e9cedff867363f70cf7bc301d6e"
    },
    {
      "id": "source-ingest-nasa-clps",
      "sourceId": "nasa-clps",
      "title": "Commercial Lunar Payload Services",
      "domain": "economics-and-business-evidence",
      "priority": "P1",
      "nextAction": "Capture a reviewed commercial-lunar-delivery-program payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-103b2187a271bdebfe18b355f043669ad9fec03243cedf0839aebc8c289670b2"
    },
    {
      "id": "source-ingest-nasa-cost-estimating-handbook",
      "sourceId": "nasa-cost-estimating-handbook",
      "title": "NASA Cost Estimating Handbook",
      "domain": "economics-and-business-evidence",
      "priority": "P1",
      "nextAction": "Capture a reviewed cost-estimating-methodology payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-f74bd3fc758ddea4d2670ac38bd556db89c2345ac4aa833a8f9e9b5388747030"
    },
    {
      "id": "source-ingest-nasa-se-handbook",
      "sourceId": "nasa-se-handbook",
      "title": "NASA Systems Engineering Handbook",
      "domain": "systems-engineering-and-governance",
      "priority": "P1",
      "nextAction": "Capture a reviewed systems-engineering-methodology payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5487d37dfcb0839e0a74edc36e4c42421e60c5a9dcd0b29821e7c0eac564757e"
    },
    {
      "id": "source-ingest-nasa-spdf",
      "sourceId": "nasa-spdf",
      "title": "NASA Space Physics Data Facility",
      "domain": "space-environment",
      "priority": "P1",
      "nextAction": "Capture a reviewed heliophysics-data-archive payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-51d99b5f2da48846e8e4a77b621cb62ef65414de2e99c0a5eac3dd87bad87621"
    },
    {
      "id": "source-ingest-nist-chemistry-webbook",
      "sourceId": "nist-chemistry-webbook",
      "title": "NIST Chemistry WebBook SRD 69",
      "domain": "materials-and-process-modeling",
      "priority": "P1",
      "nextAction": "Capture a reviewed chemistry-reference-database payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-c8ff016cbc8ee86304a0027a3a4bf3b954b1853a379196d071531f86800f2c3d"
    },
    {
      "id": "source-ingest-noaa-swpc",
      "sourceId": "noaa-swpc",
      "title": "NOAA Space Weather Prediction Center Products and Data",
      "domain": "space-environment",
      "priority": "P1",
      "nextAction": "Capture a reviewed space-weather-products payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-81ed94a99ffe23584f88770cc74cf7baf37c0aff4cf678a1f45a9a570c740bab"
    },
    {
      "id": "source-ingest-openfoam",
      "sourceId": "openfoam",
      "title": "OpenFOAM",
      "domain": "materials-and-process-modeling",
      "priority": "P1",
      "nextAction": "Capture a reviewed cfd-toolkit payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-566ae59e4e0f9d4741dfcaa81bce5623888a62582eb0729763f3dcc1953094e7"
    },
    {
      "id": "source-ingest-sec-edgar",
      "sourceId": "sec-edgar",
      "title": "SEC EDGAR",
      "domain": "economics-and-business-evidence",
      "priority": "P1",
      "nextAction": "Capture a reviewed public-company-filings payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-2fbe443ab4a09bc99bc5cf31b7633c0adf9375136831a5935e1574e13cceb994"
    },
    {
      "id": "source-ingest-spacex-rideshare",
      "sourceId": "spacex-rideshare",
      "title": "SpaceX Rideshare Program",
      "domain": "economics-and-business-evidence",
      "priority": "P1",
      "nextAction": "Capture a reviewed commercial-launch-pricing payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5ce3bc9316083ce268f83af9f6cb2470d854f556faa2d1f528d2feddd975fb01"
    },
    {
      "id": "source-ingest-usaspending",
      "sourceId": "usaspending",
      "title": "USAspending.gov",
      "domain": "economics-and-business-evidence",
      "priority": "P1",
      "nextAction": "Capture a reviewed federal-award-database payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-118104b16dfcfdaa9710627d94ccf03c2720317e8420d1ab0299f99cba314823"
    },
    {
      "id": "source-ingest-ccsds",
      "sourceId": "ccsds",
      "title": "Consultative Committee for Space Data Systems",
      "domain": "communications-and-standards",
      "priority": "P2",
      "nextAction": "Capture a reviewed space-data-standard payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-b2385bd497c44bdeeba3f2a42c96aea3d91e0a695fe68cc6558aed05260714bf"
    },
    {
      "id": "source-ingest-nasa-dtn",
      "sourceId": "nasa-dtn",
      "title": "Delay/Disruption Tolerant Networking",
      "domain": "communications-and-standards",
      "priority": "P2",
      "nextAction": "Capture a reviewed communications-program-reference payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-b3d7fd849f5c4e594460d082a7508d2df2190a6f72324f33faf3865c2f8f1bd4"
    }
  ],
  "evidenceHashes": {
    "sourceRegistry": "sha256-f71caf92b2e76cd344ad65330ce3533cc1f5657002f82b6ff69fa39acdb89780",
    "sourceRefreshReport": "sha256-40225cf6dbb39b9d856a97ea259a1b460f2a4d090182bcfdab17eac69941ad02",
    "modelArtifactBundle": "sha256-f3b0e534f4e7fb6c252f258ea4c741d6ee42b9bafb479bfb6e680c3c2d48a030",
    "modelArtifacts": "sha256-e6e59f3b72e619756d2b23d1df6f5c06d412f4bf44ecbdf6a70329e00a69da4c",
    "assumptionRegistry": "sha256-259456cb055154e66f5ca072a5045cef755874a3c2dce6b7e93be02116bece11"
  },
  "globalBlockers": [
    "No source ingestion work order can promote until a reviewed raw payload and normalized output hash exist.",
    "Social/forum material remains market intelligence only unless bridged to primary records.",
    "Runtime science tools still require sidecar artifacts before mission-design promotion.",
    "Commercial/economics records still require dated normalization before ROI or investment claims."
  ],
  "workOrders": [
    {
      "id": "source-ingest-spice-gf",
      "sourceId": "spice-gf",
      "title": "SPICE Geometry Finder",
      "organization": "NASA NAIF",
      "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
      "trust": "primary",
      "sourceType": "ephemeris-event-software",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "body-state-vectors",
        "time-scale-metadata",
        "reference-frame-trace"
      ],
      "queryPolicy": "Kernel set, target/observer/constraint, tolerance, and generated window hash required.",
      "units": [
        "TDB/ET",
        "km",
        "degrees",
        "event windows"
      ],
      "uncertaintyMode": "Kernel coverage plus geometric tolerance.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-97d74c96",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed ephemeris-event-software payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-067366bfd5d48f4d3ec03a31d3ff19007a6aa77d692b3741d5949721a6fb75b8"
    },
    {
      "id": "source-ingest-horizons-api",
      "sourceId": "horizons-api",
      "title": "JPL Horizons API",
      "organization": "NASA/JPL",
      "url": "https://ssd-api.jpl.nasa.gov/doc/horizons.html",
      "trust": "primary",
      "sourceType": "ephemeris-api",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "body-state-vectors",
        "time-scale-metadata",
        "reference-frame-trace"
      ],
      "queryPolicy": "Full Horizons query string and response timestamp required.",
      "units": [
        "TDB",
        "AU",
        "km",
        "minutes",
        "degrees"
      ],
      "uncertaintyMode": "API table tolerance plus downstream numeric tolerance.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-9335c241",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed ephemeris-api payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-87c8e4bb328d92196995c2a99ceb331d2f9e3c6616f90eb5b75f48e3a1e8af10"
    },
    {
      "id": "source-ingest-horizons-mercury-2024",
      "sourceId": "horizons-mercury-2024",
      "title": "JPL Horizons Mercury Physical Data",
      "organization": "NASA/JPL Horizons",
      "url": "https://ssd.jpl.nasa.gov/api/horizons.api?format=json&COMMAND=%27199%27&OBJ_DATA=%27YES%27&MAKE_EPHEM=%27NO%27",
      "trust": "primary",
      "sourceType": "body-physical-data",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "body-state-vectors",
        "time-scale-metadata",
        "reference-frame-trace"
      ],
      "queryPolicy": "Body-data query and retrieved physical constants required.",
      "units": [
        "days",
        "AU",
        "W/m^2"
      ],
      "uncertaintyMode": "Source-body data plus formula tolerance.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-5b941f40",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed body-physical-data payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-e7d428df65ab7cdaf3a65ff87baef2566e262a1959f270ef265ea8d5963853d8"
    },
    {
      "id": "source-ingest-nist-codata",
      "sourceId": "nist-codata",
      "title": "2022 CODATA Fundamental Physical Constants",
      "organization": "NIST",
      "url": "https://physics.nist.gov/cuu/Constants/Table/allascii.txt",
      "trust": "primary",
      "sourceType": "physical-constants",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "body-state-vectors",
        "time-scale-metadata",
        "reference-frame-trace"
      ],
      "queryPolicy": "Constants release and exact constant identifiers required.",
      "units": [
        "SI"
      ],
      "uncertaintyMode": "CODATA uncertainty or exact-SI status.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-333cff52",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed physical-constants payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5c1b9ed4354c988060da39a5fd86d1e0758fc9b447ffff3389a35c5862d4f85d"
    },
    {
      "id": "source-ingest-sbdb-api",
      "sourceId": "sbdb-api",
      "title": "JPL Small-Body Database API",
      "organization": "NASA/JPL",
      "url": "https://ssd-api.jpl.nasa.gov/doc/sbdb.html",
      "trust": "primary",
      "sourceType": "small-body-orbit-api",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "object-record",
        "observation-bridge",
        "taxonomy-or-mission-product"
      ],
      "queryPolicy": "Object query, orbit solution date, and physical-property provenance required.",
      "units": [
        "AU",
        "km/s",
        "H",
        "diameter",
        "orbit condition code"
      ],
      "uncertaintyMode": "Orbit condition code, diameter uncertainty, and physical-data caveats.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-93c0fe91",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed small-body-orbit-api payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-03df633e2ee73cac09d65f2a2f5428e468e6ac89008e3f4378d6c8fd575ca8a5"
    },
    {
      "id": "source-ingest-cad-api",
      "sourceId": "cad-api",
      "title": "SBDB Close Approach Data API",
      "organization": "NASA/JPL CNEOS",
      "url": "https://ssd-api.jpl.nasa.gov/doc/cad.html",
      "trust": "primary",
      "sourceType": "close-approach-api",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "object-record",
        "observation-bridge",
        "taxonomy-or-mission-product"
      ],
      "queryPolicy": "Date range, distance threshold, sort order, and close-approach record hash required.",
      "units": [
        "AU",
        "km/s",
        "date"
      ],
      "uncertaintyMode": "Nominal approach values with orbit-solution caveats.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-ba0c45bb",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed close-approach-api payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-ae487ba413cc055f5780b588f01397328e6b175869437d23576aad46b9b9ce71"
    },
    {
      "id": "source-ingest-orekit",
      "sourceId": "orekit",
      "title": "Orekit",
      "organization": "CS Group / open source community",
      "url": "https://www.orekit.org/",
      "trust": "open-source",
      "sourceType": "astrodynamics-library",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "runtime-artifact",
        "residual-summary",
        "cross-tool-comparison"
      ],
      "queryPolicy": "Tool version, data context, frames, force model, and checksums required.",
      "units": [
        "frames",
        "time scales",
        "state vectors",
        "events"
      ],
      "uncertaintyMode": "Model configuration and independent comparison residuals.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-88a8d672",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed astrodynamics-library payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-32e680e406eeddf3facdf231b3f530178321968183591cbb59f8a4f88d12eec3"
    },
    {
      "id": "source-ingest-gmat",
      "sourceId": "gmat",
      "title": "General Mission Analysis Tool",
      "organization": "NASA",
      "url": "https://software.nasa.gov/software/GSC-17177-1",
      "trust": "primary",
      "sourceType": "mission-analysis-tool",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "runtime-artifact",
        "residual-summary",
        "cross-tool-comparison"
      ],
      "queryPolicy": "GMAT script hash, version, force model, optimizer, and run summary required.",
      "units": [
        "km",
        "km/s",
        "seconds",
        "constraints"
      ],
      "uncertaintyMode": "Constraint residuals and cross-tool comparison.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-3743e565",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed mission-analysis-tool payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-9dc7bf9fb79de628782cf8b0323b4f3813914992b426fe4dc7a3daf3eae8833d"
    },
    {
      "id": "source-ingest-openmdao",
      "sourceId": "openmdao",
      "title": "OpenMDAO",
      "organization": "NASA",
      "url": "https://openmdao.org/",
      "trust": "primary",
      "sourceType": "optimization-framework",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "runtime-artifact",
        "residual-summary",
        "cross-tool-comparison"
      ],
      "queryPolicy": "Problem definition, design variables, constraints, objective, and seed required.",
      "units": [
        "dimensionless",
        "scenario-specific"
      ],
      "uncertaintyMode": "Sensitivity and optimizer-convergence metadata.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-9ef7d3cb",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed optimization-framework payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-c6f5e90eb17541785cd427c2bbd3aa01691aca58bd56e984e39f91c732f1a20b"
    },
    {
      "id": "source-ingest-dymos",
      "sourceId": "dymos",
      "title": "Dymos",
      "organization": "OpenMDAO project",
      "url": "https://openmdao.github.io/dymos/",
      "trust": "open-source",
      "sourceType": "optimal-control-library",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "runtime-artifact",
        "residual-summary",
        "cross-tool-comparison"
      ],
      "queryPolicy": "Problem definition, transcription, optimizer, constraints, objective, and run seed required.",
      "units": [
        "states",
        "controls",
        "constraints",
        "objective values"
      ],
      "uncertaintyMode": "Convergence status, sensitivity, and collocation residuals.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-31dbd31c",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed optimal-control-library payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5f0c857d5f01ab9369fac47f0b965676cd1d5551ba22f91f1294e64872c344d0"
    },
    {
      "id": "source-ingest-tudat",
      "sourceId": "tudat",
      "title": "Tudat Space / TudatPy",
      "organization": "TU Delft Astrodynamics Toolbox community",
      "url": "https://docs.tudat.space/en/latest/",
      "trust": "open-source",
      "sourceType": "astrodynamics-toolkit",
      "domain": "trajectory-and-optimization",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "runtime-artifact",
        "residual-summary",
        "cross-tool-comparison"
      ],
      "queryPolicy": "Tool version, body settings, integrator, propagator, and output hashes required.",
      "units": [
        "state vectors",
        "epochs",
        "frames",
        "residuals"
      ],
      "uncertaintyMode": "Integrator settings, model configuration, and cross-tool residual bounds.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-c238f1d2",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed astrodynamics-toolkit payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-036f1a6704d95b5f93ff6bca5ea75a05e823e85cb50ec2048eda3a5267a33a1a"
    },
    {
      "id": "source-ingest-iau-sofa",
      "sourceId": "iau-sofa",
      "title": "Standards of Fundamental Astronomy",
      "organization": "IAU SOFA",
      "url": "https://www.iausofa.org/",
      "trust": "primary",
      "sourceType": "astronomy-standards",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "body-state-vectors",
        "time-scale-metadata",
        "reference-frame-trace"
      ],
      "queryPolicy": "Routine/version reference and transformation chain required.",
      "units": [
        "time scales",
        "reference frames"
      ],
      "uncertaintyMode": "Standards conformance and transform precision.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-2a854c84",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed astronomy-standards payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-4e64bcced35d7a9497724400b98fb6e2a86515ae74b1c7048f63bbad8b99f06e"
    },
    {
      "id": "source-ingest-pds",
      "sourceId": "pds",
      "title": "Planetary Data System",
      "organization": "NASA",
      "url": "https://pds.nasa.gov/datasearch/data-search/",
      "trust": "primary",
      "sourceType": "mission-data-archive",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "object-record",
        "observation-bridge",
        "taxonomy-or-mission-product"
      ],
      "queryPolicy": "Mission, instrument, product id, bundle, and citation required.",
      "units": [
        "instrument-specific"
      ],
      "uncertaintyMode": "Instrument/product calibration metadata.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-7c477cc2",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed mission-data-archive payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-928a0c47b33ef9948c19972c1b4ecf480cf557b36aad1191673dce710ab29a11"
    },
    {
      "id": "source-ingest-mpc",
      "sourceId": "mpc",
      "title": "Minor Planet Center Data",
      "organization": "International Astronomical Union Minor Planet Center",
      "url": "https://minorplanetcenter.net/data",
      "trust": "primary",
      "sourceType": "small-body-observation-archive",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "object-record",
        "observation-bridge",
        "taxonomy-or-mission-product"
      ],
      "queryPolicy": "Object designation, observation batch, citation, and retrieval timestamp required.",
      "units": [
        "designation",
        "observation time",
        "astrometry"
      ],
      "uncertaintyMode": "Observation residuals and orbit-solution bridge to SBDB/CAD.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-62694497",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed small-body-observation-archive payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-6f4ec4d25fd364055d8c199c2c900fb140fcfd4c471ff4343dd8cb45ab928bc7"
    },
    {
      "id": "source-ingest-esa-psa",
      "sourceId": "esa-psa",
      "title": "ESA Planetary Science Archive",
      "organization": "European Space Agency",
      "url": "https://archives.esac.esa.int/psa/",
      "trust": "primary",
      "sourceType": "planetary-mission-archive",
      "domain": "small-body-and-resource-evidence",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "object-record",
        "observation-bridge",
        "taxonomy-or-mission-product"
      ],
      "queryPolicy": "Mission, instrument, product id, citation, and license/use terms required.",
      "units": [
        "mission/product-specific"
      ],
      "uncertaintyMode": "Product calibration, processing level, and instrument caveats.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-5c0abe4d",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed planetary-mission-archive payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-e943bde41a94f1789b36698e84beaf971e81fece7b2e6162591edfd8afdad615"
    },
    {
      "id": "source-ingest-jaxa-darts",
      "sourceId": "jaxa-darts",
      "title": "DARTS Space Science Data Archive",
      "organization": "ISAS/JAXA",
      "url": "https://darts.isas.jaxa.jp/",
      "trust": "primary",
      "sourceType": "space-science-archive",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "body-state-vectors",
        "time-scale-metadata",
        "reference-frame-trace"
      ],
      "queryPolicy": "Mission, dataset, product id, retrieval timestamp, and citation required.",
      "units": [
        "mission/product-specific"
      ],
      "uncertaintyMode": "Dataset calibration and archive release notes.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-e07b656d",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed space-science-archive payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-a4b69d55b7d4cc9a233b493a92ff3e8497fcf65a45bf8e332e389d21af096fb2"
    },
    {
      "id": "source-ingest-nasa-mercury",
      "sourceId": "nasa-mercury",
      "title": "Mercury Facts",
      "organization": "NASA Science",
      "url": "https://science.nasa.gov/mercury/facts/",
      "trust": "primary",
      "sourceType": "official-factsheet",
      "domain": "ephemeris-and-astronomy",
      "priority": "P0",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "body-state-vectors",
        "time-scale-metadata",
        "reference-frame-trace"
      ],
      "queryPolicy": "Page URL, access date, and derived-calculation trace required.",
      "units": [
        "AU",
        "days",
        "K",
        "W/m^2 context"
      ],
      "uncertaintyMode": "Factsheet summary caveats; not a substitute for mission data.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-78229f8d",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed official-factsheet payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5b53cd471db10365d2e0a9126eb6fd841ddbed0292a6202d9865d5c32e634bb3"
    },
    {
      "id": "source-ingest-nasa-dtn",
      "sourceId": "nasa-dtn",
      "title": "Delay/Disruption Tolerant Networking",
      "organization": "NASA SCaN",
      "url": "https://www.nasa.gov/communicating-with-missions/delay-disruption-tolerant-networking/",
      "trust": "primary",
      "sourceType": "communications-program-reference",
      "domain": "communications-and-standards",
      "priority": "P2",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "standard-reference",
        "architecture-assumption",
        "implementation-delta"
      ],
      "queryPolicy": "Program reference, architecture assumption, and scenario mapping required.",
      "units": [
        "protocol concepts",
        "network behavior"
      ],
      "uncertaintyMode": "Conceptual architecture until mission-specific link data exists.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-61e03fe6",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed communications-program-reference payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-b3d7fd849f5c4e594460d082a7508d2df2190a6f72324f33faf3865c2f8f1bd4"
    },
    {
      "id": "source-ingest-spacex-rideshare",
      "sourceId": "spacex-rideshare",
      "title": "SpaceX Rideshare Program",
      "organization": "SpaceX",
      "url": "https://www.spacex.com/rideshare/",
      "trust": "commercial-primary",
      "sourceType": "commercial-launch-pricing",
      "domain": "economics-and-business-evidence",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "dated-cost-record",
        "normalization-method",
        "uncertainty-band"
      ],
      "queryPolicy": "Capture provider page, access timestamp, price table text, destination/orbit class, and terms caveats before use.",
      "units": [
        "USD",
        "kg",
        "orbit class",
        "payload envelope"
      ],
      "uncertaintyMode": "Commercial list price caveats, mission-specific integration costs, schedule, destination, and contract terms.",
      "license": "Commercial public web page; quote minimally and preserve citation rather than redistributing raw content.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-86aacff8",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed commercial-launch-pricing payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5ce3bc9316083ce268f83af9f6cb2470d854f556faa2d1f528d2feddd975fb01"
    },
    {
      "id": "source-ingest-nasa-clps",
      "sourceId": "nasa-clps",
      "title": "Commercial Lunar Payload Services",
      "organization": "NASA",
      "url": "https://www.nasa.gov/commercial-lunar-payload-services/",
      "trust": "primary",
      "sourceType": "commercial-lunar-delivery-program",
      "domain": "economics-and-business-evidence",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "dated-cost-record",
        "normalization-method",
        "uncertainty-band"
      ],
      "queryPolicy": "Capture NASA program page, date, task-order references, provider, payload mass/context, and award amount where available.",
      "units": [
        "USD",
        "payload count",
        "delivery count",
        "contract envelope"
      ],
      "uncertaintyMode": "Task-order scope, modifications, mission risk, provider performance, and payload-specific services.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-7d151be6",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed commercial-lunar-delivery-program payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-103b2187a271bdebfe18b355f043669ad9fec03243cedf0839aebc8c289670b2"
    },
    {
      "id": "source-ingest-nasa-cost-estimating-handbook",
      "sourceId": "nasa-cost-estimating-handbook",
      "title": "NASA Cost Estimating Handbook",
      "organization": "NASA",
      "url": "https://www.nasa.gov/reference/nasa-cost-estimating-handbook/",
      "trust": "primary",
      "sourceType": "cost-estimating-methodology",
      "domain": "economics-and-business-evidence",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "dated-cost-record",
        "normalization-method",
        "uncertainty-band"
      ],
      "queryPolicy": "Document handbook version, estimating method, normalization year, risk treatment, and applied model assumptions.",
      "units": [
        "cost estimate classes",
        "risk",
        "schedule",
        "uncertainty"
      ],
      "uncertaintyMode": "Method selection, analogy quality, learning curves, schedule risk, and normalization assumptions.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-a82e1046",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed cost-estimating-methodology payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-f74bd3fc758ddea4d2670ac38bd556db89c2345ac4aa833a8f9e9b5388747030"
    },
    {
      "id": "source-ingest-nasa-se-handbook",
      "sourceId": "nasa-se-handbook",
      "title": "NASA Systems Engineering Handbook",
      "organization": "NASA",
      "url": "https://www.nasa.gov/reference/systems-engineering-handbook/",
      "trust": "primary",
      "sourceType": "systems-engineering-methodology",
      "domain": "systems-engineering-and-governance",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "maturity-gate",
        "verification-rule",
        "review-evidence"
      ],
      "queryPolicy": "Document handbook version, review/maturity concept used, and mapping to scenario/process gates.",
      "units": [
        "life-cycle phase",
        "maturity",
        "verification",
        "validation"
      ],
      "uncertaintyMode": "Program-specific tailoring and maturity-assessment subjectivity.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-991637e4",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed systems-engineering-methodology payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5487d37dfcb0839e0a74edc36e4c42421e60c5a9dcd0b29821e7c0eac564757e"
    },
    {
      "id": "source-ingest-usaspending",
      "sourceId": "usaspending",
      "title": "USAspending.gov",
      "organization": "U.S. Treasury / federal agencies",
      "url": "https://www.usaspending.gov/",
      "trust": "primary",
      "sourceType": "federal-award-database",
      "domain": "economics-and-business-evidence",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "dated-cost-record",
        "normalization-method",
        "uncertainty-band"
      ],
      "queryPolicy": "Preserve query filters, award id, recipient, agency, obligation amounts, date range, and retrieval hash.",
      "units": [
        "USD",
        "award id",
        "recipient",
        "obligation",
        "period of performance"
      ],
      "uncertaintyMode": "Award modification timing, obligation versus outlay, scope classification, and recipient hierarchy.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-fb43b155",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed federal-award-database payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-118104b16dfcfdaa9710627d94ccf03c2720317e8420d1ab0299f99cba314823"
    },
    {
      "id": "source-ingest-sec-edgar",
      "sourceId": "sec-edgar",
      "title": "SEC EDGAR",
      "organization": "U.S. Securities and Exchange Commission",
      "url": "https://www.sec.gov/edgar",
      "trust": "primary",
      "sourceType": "public-company-filings",
      "domain": "economics-and-business-evidence",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "dated-cost-record",
        "normalization-method",
        "uncertainty-band"
      ],
      "queryPolicy": "Preserve CIK/ticker, accession number, filing date, statement section, XBRL fields, and retrieval hash.",
      "units": [
        "USD",
        "filing date",
        "fiscal period",
        "risk factors"
      ],
      "uncertaintyMode": "Company-specific accounting policy, segment allocation, forward-looking statements, and market-cycle caveats.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-f2e84204",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed public-company-filings payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-2fbe443ab4a09bc99bc5cf31b7633c0adf9375136831a5935e1574e13cceb994"
    },
    {
      "id": "source-ingest-ccsds",
      "sourceId": "ccsds",
      "title": "Consultative Committee for Space Data Systems",
      "organization": "CCSDS member agencies",
      "url": "https://ccsds.org/",
      "trust": "primary",
      "sourceType": "space-data-standard",
      "domain": "communications-and-standards",
      "priority": "P2",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "standard-reference",
        "architecture-assumption",
        "implementation-delta"
      ],
      "queryPolicy": "Publication id, version, area, and applied assumption required.",
      "units": [
        "standard-specific"
      ],
      "uncertaintyMode": "Standards conformance caveats and mission-specific implementation deltas.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-75fdfe19",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed space-data-standard payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-b2385bd497c44bdeeba3f2a42c96aea3d91e0a695fe68cc6558aed05260714bf"
    },
    {
      "id": "source-ingest-nasa-spdf",
      "sourceId": "nasa-spdf",
      "title": "NASA Space Physics Data Facility",
      "organization": "NASA Goddard",
      "url": "https://spdf.gsfc.nasa.gov/",
      "trust": "primary",
      "sourceType": "heliophysics-data-archive",
      "domain": "space-environment",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "environment-time-series",
        "hazard-index",
        "archive-or-model-run-id"
      ],
      "queryPolicy": "Dataset id, variables, time range, cadence, and retrieval hash required.",
      "units": [
        "CDF",
        "mission-specific plasma/radiation fields"
      ],
      "uncertaintyMode": "Instrument calibration, cadence, and archive-version caveats.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-05f4400c",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed heliophysics-data-archive payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-51d99b5f2da48846e8e4a77b621cb62ef65414de2e99c0a5eac3dd87bad87621"
    },
    {
      "id": "source-ingest-nasa-ccmc",
      "sourceId": "nasa-ccmc",
      "title": "Community Coordinated Modeling Center",
      "organization": "NASA Goddard",
      "url": "https://ccmc.gsfc.nasa.gov/",
      "trust": "primary",
      "sourceType": "space-weather-modeling-center",
      "domain": "space-environment",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "environment-time-series",
        "hazard-index",
        "archive-or-model-run-id"
      ],
      "queryPolicy": "Model, run id, inputs, version, and output hash required.",
      "units": [
        "model-specific"
      ],
      "uncertaintyMode": "Model validation state, run configuration, and uncertainty bounds.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-1a450de5",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed space-weather-modeling-center payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-5c43fc31587c76573078911a506a40bae0680e9cedff867363f70cf7bc301d6e"
    },
    {
      "id": "source-ingest-noaa-swpc",
      "sourceId": "noaa-swpc",
      "title": "NOAA Space Weather Prediction Center Products and Data",
      "organization": "NOAA/NWS",
      "url": "https://www.spaceweather.gov/products-and-data",
      "trust": "primary",
      "sourceType": "space-weather-products",
      "domain": "space-environment",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "environment-time-series",
        "hazard-index",
        "archive-or-model-run-id"
      ],
      "queryPolicy": "Product id, issue time, forecast horizon, and archive link required.",
      "units": [
        "Kp",
        "Ap",
        "F10.7",
        "particle flux",
        "alerts"
      ],
      "uncertaintyMode": "Forecast horizon and product-specific verification notes.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-dbbbdd09",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed space-weather-products payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-81ed94a99ffe23584f88770cc74cf7baf37c0aff4cf678a1f45a9a570c740bab"
    },
    {
      "id": "source-ingest-nist-chemistry-webbook",
      "sourceId": "nist-chemistry-webbook",
      "title": "NIST Chemistry WebBook SRD 69",
      "organization": "NIST",
      "url": "https://webbook.nist.gov/chemistry/",
      "trust": "primary",
      "sourceType": "chemistry-reference-database",
      "domain": "materials-and-process-modeling",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "material-property-record",
        "process-model-artifact",
        "solver-residuals"
      ],
      "queryPolicy": "Species identifier, property table, units, citation, and access date required.",
      "units": [
        "thermochemical",
        "thermophysical",
        "spectral"
      ],
      "uncertaintyMode": "NIST data notes, property method, and cited evaluation caveats.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-d9ac987b",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed chemistry-reference-database payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-c8ff016cbc8ee86304a0027a3a4bf3b954b1853a379196d071531f86800f2c3d"
    },
    {
      "id": "source-ingest-materials-project",
      "sourceId": "materials-project",
      "title": "Materials Project API",
      "organization": "Lawrence Berkeley National Laboratory / Materials Project",
      "url": "https://docs.materialsproject.org/downloading-data/using-the-api",
      "trust": "primary",
      "sourceType": "materials-property-api",
      "domain": "materials-and-process-modeling",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "material-property-record",
        "process-model-artifact",
        "solver-residuals"
      ],
      "queryPolicy": "mp-id, fields, API version/client, method metadata, and retrieval hash required.",
      "units": [
        "material-specific"
      ],
      "uncertaintyMode": "DFT/method limitations, provenance, and contributed-data caveats.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-c46b2daa",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed materials-property-api payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-cf340e050bde6a9a086fea668420d741780db2d71381b6b8de0222967e39b600"
    },
    {
      "id": "source-ingest-cantera",
      "sourceId": "cantera",
      "title": "Cantera",
      "organization": "Cantera project",
      "url": "https://cantera.org/",
      "trust": "open-source",
      "sourceType": "chemistry-transport-toolkit",
      "domain": "materials-and-process-modeling",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "material-property-record",
        "process-model-artifact",
        "solver-residuals"
      ],
      "queryPolicy": "Mechanism file, tool version, inputs, outputs, and mechanism hash required.",
      "units": [
        "species",
        "reactions",
        "transport",
        "temperature",
        "pressure"
      ],
      "uncertaintyMode": "Mechanism validity range and solver tolerance.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-883bdb34",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed chemistry-transport-toolkit payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-db1a361118b0599a32f646adbfd56174b3632166b2e0ecee2f1a8033a365161b"
    },
    {
      "id": "source-ingest-moose-framework",
      "sourceId": "moose-framework",
      "title": "MOOSE Framework",
      "organization": "Idaho National Laboratory",
      "url": "https://mooseframework.inl.gov/",
      "trust": "primary",
      "sourceType": "multiphysics-framework",
      "domain": "materials-and-process-modeling",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "material-property-record",
        "process-model-artifact",
        "solver-residuals"
      ],
      "queryPolicy": "Input file, application/version, mesh hash, material data, and output hash required.",
      "units": [
        "mesh",
        "material properties",
        "PDE residuals",
        "solver tolerances"
      ],
      "uncertaintyMode": "Discretization, mesh convergence, solver residuals, and material uncertainty.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-a9482599",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed multiphysics-framework payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-f78f596ae140aade5b7d0fd53aa491e4a0478dca93cf5ea1c391bfe57ba93d7a"
    },
    {
      "id": "source-ingest-openfoam",
      "sourceId": "openfoam",
      "title": "OpenFOAM",
      "organization": "OpenCFD / OpenFOAM community",
      "url": "https://www.openfoam.com/",
      "trust": "open-source",
      "sourceType": "cfd-toolkit",
      "domain": "materials-and-process-modeling",
      "priority": "P1",
      "ingestionState": "contract-ready-no-reviewed-payload",
      "claimState": "ingestion-work-order-only",
      "requiredPayloadArtifacts": [
        "queryOrRequest",
        "captureTimestamp",
        "rawPayloadHash",
        "normalizedRecordHash",
        "licenseOrTermsReview",
        "unitsMap",
        "uncertaintyMap",
        "citation",
        "parserVersion",
        "fixtureOrToleranceTest",
        "reviewerApproval"
      ],
      "normalizedOutputs": [
        "material-property-record",
        "process-model-artifact",
        "solver-residuals"
      ],
      "queryPolicy": "Case directory hash, solver/version, mesh, boundary conditions, and result hash required.",
      "units": [
        "mesh",
        "fields",
        "boundary conditions",
        "solver residuals"
      ],
      "uncertaintyMode": "Mesh convergence, turbulence model, chemistry model, and boundary-condition uncertainty.",
      "license": "Public-source review required before redistribution of raw payloads.",
      "refreshPolicy": "Snapshot-first; live refresh must preserve query, units, uncertainty, and record hash.",
      "sourceRecordHash": "fnv1a32-124056ab",
      "promotionAllowed": false,
      "blockers": [
        "No raw source payload hash has been attached to this ingestion work order.",
        "No normalized parser output has been reviewed for promotion.",
        "No reviewer approval has promoted this source into a model-ready record."
      ],
      "nextAction": "Capture a reviewed cfd-toolkit payload with raw and normalized hashes before this source can promote model outputs.",
      "workOrderHash": "sha256-566ae59e4e0f9d4741dfcaa81bce5623888a62582eb0729763f3dcc1953094e7"
    }
  ],
  "ledgerHash": "sha256-0e4319b9702f975d686339d93606beee2b5e4eca89d04e721b2ecf61493690c2"
}
;
